import React from 'react'
import { Navigate } from 'react-router'

import RqCertifiedActionButtons from '@/components/layouts/RqCertifiedLayout/components/RqCertifiedActionButtons/RqCertifiedActionButtons'
import RqCertifiedPageHeader from '@/components/layouts/RqCertifiedLayout/components/RqCertifiedPageHeader'
import PageContainer from '@/components/misc/PageContainer'
import { Card, CardContent } from '@/components/ui/card'
import useAppSelector from '@/hooks/useAppSelector'
import { useHomeRoute } from '@/hooks/useHomeRoute'
import { useRqCertifiedAssessment } from '@/hooks/useRqCertifiedAssessmentQuery'
import { selectIsIfa } from '@/redux/slices/session'

interface Props {
  children: React.ReactNode
}

const RqCertifiedLayout: React.FC<Props> = ({ children }) => {
  const isIfa = useAppSelector(selectIsIfa)
  const homeRoute = useHomeRoute()
  const assessment = useRqCertifiedAssessment()

  if (!isIfa || !assessment) {
    return <Navigate to={homeRoute} />
  }

  return (
    <>
      <RqCertifiedPageHeader />

      <PageContainer>
        <Card className="max-7xl">
          <CardContent>
            {children}
            <RqCertifiedActionButtons />
          </CardContent>
        </Card>
      </PageContainer>
    </>
  )
}

export default RqCertifiedLayout
